import styled from 'styled-components';

export const MaternityDetails = styled.div`

`
